var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buybox-add-to-cart-feature has-spacing-small"},[_c('add-to-cart-button',{attrs:{"variant":_vm.variant,"quantity":_vm.quantity}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }